import React, { useEffect, useRef } from "react";
import mermaid from "mermaid";
import "./Mermaid.scss";

export default function MermaidDiagram({ content }: { content: string }) {
  const mermaidRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (content && mermaidRef.current) {
      mermaid.initialize({ startOnLoad: true });
      mermaid.contentLoaded();
    }
  }, [content]);

  return (
    <div ref={mermaidRef}>
      <div className="mermaid">{content}</div>
    </div>
  );
}
